import React, { useState } from "react";
import LockerMapMobile from "./LockerMapMobile";
import { useHistory } from "react-router-dom";
import CircularProgressLoader from "./CircularProgressLoader";
import ShowToast from "./ToastComponent";
import { TOAST_ERROR } from "../assets/constants/Constants";
import {
  fetchNearbyLockersForLocation,
  getCurrentBrowserLocation,
  getNearbyLockerErrorMessage,
} from "../lib/NearbyLockerUtils";

const LockerMapPreview = () => {
  const [isLocating, setIsLocating] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const [loadingMessage, setLoadingMessage] = useState("");

  const history = useHistory();

  // Default location (Pune)
  const defaultLocation = {
    lat: 18.5292,
    lng: 73.8746,
  };

  const handleFindLockers = async () => {
    setIsLocating(true);
    setShowLoader(true);
    setLoadingMessage("Getting your location...");

    try {
      const userLocation = await getCurrentBrowserLocation();
      const { lockersData: apiData } = await fetchNearbyLockersForLocation({
        userLocation,
        onLoadingMessage: setLoadingMessage,
      });

      setTimeout(() => {
        setShowLoader(false);

        history.push({
          pathname: "/map",
          state: {
            center: userLocation,
            useUserLocation: true,
            lockersData: apiData,
            timestamp: Date.now()
          },
        });
      }, 500);
    } catch (error) {
      console.log("Nearby locker flow error:", error);
      const message = getNearbyLockerErrorMessage(error);
      setShowLoader(false);
      ShowToast(message, TOAST_ERROR);
    } finally {
      setIsLocating(false);
    }
  };

  return (
      <div className="locker-map-preview"  onClick={handleFindLockers}>
        <div className="preview-map-container">
          <div className="mini-map-wrapper">
            <LockerMapMobile
              isPreview={true}
              initialLocation={defaultLocation}
            />
          </div>
        </div>
        <div
          className={`find-lockers-btn-container ${
            isLocating ? "locating" : ""
          }`}
          onClick={handleFindLockers}
        >
          <h1 className="find-locker-heading">
            {isLocating
              ? "Getting your location..."
              : "Search Lockers Near Me"}
          </h1>
        </div>
        {showLoader && (
        <CircularProgressLoader message={loadingMessage} />
      )}
      </div>

      
  );
};

export default LockerMapPreview;
